import styled from 'styled-components'

export const Container = styled.div<{ show: boolean }>`
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 1040;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    padding: 0;
    display: ${({ show }) => (show ? 'block' : 'none')};
    overflow: hidden;
`
export const Header = styled.div`
    position: fixed;
    width: 100%;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 40px;
    background: #eee;
    margin: 0;
    padding-left: 30px;
`

export const Content = styled.div`
    background: white;
    padding-top: 58px;
    overflow-y: auto;
    height: 100%;
    overflow-x: hidden;
`

export const Title = styled.div`
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: center;
    justify-content: center;
    text-transform: capitalize;
    padding-top: 1px;
    height: 25px;
    line-height: 25px;
    margin-right: 2px;
    font-family: ${({ theme }) => theme['font-bold']};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #606a80;
    > div:nth-child(2) {
        padding-left: 2px;
        font-weight: 600;
        color: #364159;
    }
    ${({ first }) =>
        first &&
        `
        padding-left: 20px;
    `}
`

export const TitleValue = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
    margin-right: 20px;
`

export const ContainerStatus = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 13px;
    margin-left: auto;
    > a {
        text-decoration: none;
    }
    > a > i {
        cursor: pointer;
        width: 45px;
        height: 40px;
        border-left: 1px solid #dddee1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #37a3ef;
        font-family: Font Awesome 5 Pro;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
    }
`
export const Status = styled.div`
    display: flex;
    margin-right: 24px;
    > div:first-child {
        margin-right: 8px;
        display: block;
        font-family: ${({ theme }) => theme['font-regular']};
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        text-transform: uppercase;
        color: #606a80;
        padding-top: 3px;
    }

    > div:nth-child(2) {
        display: block;
        font-family: ${({ theme }) => theme['font-bold']};
        font-style: normal;
        font-weight: 600;
        font-size: 11px;
        text-transform: capitalize;
        color: #364159;
        padding-top: 3px;
    }
`
